var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.662598 15.4824C0.263672 15.0928 0.272949 14.4062 0.662598 14.0259L6.36816 8.31104L0.662598 2.60547C0.272949 2.2251 0.263672 1.54785 0.662598 1.13965C1.06152 0.740723 1.73877 0.75 2.12842 1.13965L7.83398 6.84521L13.5396 1.13965C13.9385 0.75 14.5972 0.75 15.0054 1.14893C15.4136 1.53857 15.4043 2.21582 15.0146 2.60547L9.30908 8.31104L15.0146 14.0259C15.4043 14.4155 15.4043 15.0835 15.0054 15.4824C14.6064 15.8906 13.9385 15.8813 13.5396 15.4917L7.83398 9.78613L2.12842 15.4917C1.73877 15.8813 1.0708 15.8813 0.662598 15.4824Z",
    fill: "#5A5976"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6f9ef2ea5dffecd854fb1fcf29e92a09.svg";
export { ForwardRef as ReactComponent };